export default {
  errorsRootKey: 'superAdmins.fields',
  resource: 'users/super-admin',
  actions: ['index', 'show', 'create', 'update', 'destroy'],

  resetPassword(id, data, options = {}) {
    return Vue.http.put(
      `users/super-admin/${id}/reset-password`,
      data,
      {options}
    ).then(
      response => response.data,
      response => {
        throw response.data.errors
      }
    )
  }

}
